module.exports = __webpack_public_path__ + "static/media/success.1a4eee6c.svg";